var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['tag', _vm.type, { 'icon-filled': _vm.iconFilled, 'no-overflow': _vm.noOverflow }]},[(_vm.icon)?_c('div',{staticClass:"md-icon"},[_vm._v(_vm._s(_vm.icon))]):_vm._e(),_c('div',{staticClass:"text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }